import React from 'react'

const GuidanceAndGuideLines = () => {
  return (
    <div style={{ color: 'white' }}></div>
  )
}

export default GuidanceAndGuideLines